import Header from 'components/modules/Header/Header';
import SubHeader from 'components/modules/Header/SubHeader';
import Sidebar from 'components/modules/Sidebar/Sidebar';
import styles from './Default.module.scss';
// import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QuestionFilter from 'components/modules/QuestionFilter/QuestionFilter';


type Props = {
  children: React.ReactNode;
};

// const Default = ({ children }: Props) => (
//   <main className="bg-blue">
//     <Header />

//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-md-2">
//           <Sidebar />
//         </div>
//         <div className="col-md-10">
//           <div className="row">
//             {children}
//           </div>
//         </div>
//       </div>
//     </div>
//     <ToastContainer />
//   </main>
// );

const Question = ({ children }: Props) => (
  <main className="bg-blue">
    <Header />
     <SubHeader />
    <div className="wrapper" style={{marginTop:"20px"}}>
      <Sidebar />
      <QuestionFilter/>
      <div id="content">
        <div className="container-fluid">
          <div className="row">
            {children}
          </div>

        </div>
      </div>
    </div>

     {/* <Header />
     <SubHeader />
    <div className="wrapper">
      <Sidebar />
      
      <div id="content">
        <div className="container-fluid">
          <div className="row">
            {children}
          </div>

        </div>
      </div>
    </div> */}
    {/* <Header />

    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <Sidebar />
        </div>
        <div className="col-md-10">
          <div className="row">
            {children}
          </div>
        </div>
      </div>
    </div>
    <ToastContainer /> */}
  </main>
);
export default Question;
